import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { targetModalId: String }

  openCsvModal() {
    // Close the StimulusReflex modal by clearing the modal container
    const modalContainer = document.getElementById('modal_container')
    if (modalContainer) {
      modalContainer.innerHTML = ''
    }

    // Open the CSV upload modal
    if (this.targetModalIdValue) {
      const csvModal = document.getElementById(this.targetModalIdValue)
      if (csvModal) {
        csvModal.showModal()
      }
    }
  }
}
